import { c as _c } from "react/compiler-runtime";
import '@src/theme/styles/globals.css';
import '@src/theme/styles/fonts';
import { Box, ChakraProvider } from '@chakra-ui/react';
import { useWindow } from '@src/hooks/useWindow.tsx';
import { DESIGN_SYSTEM_COOKIE, getDesignSystemOverride } from '@src/lib/designSystemOverride';
import { IS_SERVER_SIDE } from '@src/lib/server-side-rendering';
import { getDesignSystem, getDesignSystemColorPalette } from '@src/theme';
import Cookie from 'js-cookie';
import { ColorModeProvider, type ColorModeProviderProps } from './color-mode';
export function ScoChakraProvider(props) {
  const $ = _c(21);
  const windowProxy = useWindow();
  const isAdmin = windowProxy?.location?.pathname?.startsWith("/admin");
  let t0;
  if ($[0] !== props.designSystemOverride) {
    t0 = IS_SERVER_SIDE ? props.designSystemOverride : Cookie.get(DESIGN_SYSTEM_COOKIE);
    $[0] = props.designSystemOverride;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = getDesignSystemOverride(t0);
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const designSystemOverride = t1;
  const defaultDesignSystemKey = designSystemOverride ? `${designSystemOverride}${isAdmin ? "-admin" : ""}` : isAdmin ? "admin" : "sco";
  const designSystemKey = props.designSystemKey || defaultDesignSystemKey;
  let t2;
  if ($[4] !== designSystemKey) {
    t2 = getDesignSystemColorPalette(designSystemKey);
    $[4] = designSystemKey;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const colorPalette = t2;
  let t3;
  if ($[6] !== designSystemKey) {
    t3 = getDesignSystem(designSystemKey);
    $[6] = designSystemKey;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = props.colorPalette || colorPalette._dark;
  const t5 = props.colorPalette || colorPalette._light;
  let t6;
  if ($[8] !== t4 || $[9] !== t5) {
    t6 = {
      _dark: t4,
      _light: t5
    };
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== designSystemKey || $[12] !== props.children || $[13] !== t6) {
    t7 = <Box data-design-system={designSystemKey} colorPalette={t6}>{props.children}</Box>;
    $[11] = designSystemKey;
    $[12] = props.children;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t3 || $[16] !== t7) {
    t8 = <ChakraProvider value={t3}>{t7}</ChakraProvider>;
    $[15] = t3;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== props || $[19] !== t8) {
    t9 = <ColorModeProvider defaultColorMode="dark" {...props}>{t8}</ColorModeProvider>;
    $[18] = props;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
}